// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".btn-loader{\n  animation:spin 1s linear infinite\n}\n@keyframes spin{\nto{\n    transform:rotate(1turn)\n}\n}\n.btn-loader_m{\n  width:28px\n}\n.btn-loader_s{\n  width:18px\n}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
